import { useEffect } from "react";

export const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Политика за поверителност – Stamsy Art";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container my-5" style={{ maxWidth: "800px" }}>
      <h2 style={{ marginBottom: "8px" }}>Политика за поверителност</h2>
      <p style={{ color: "#888", fontSize: "13px", marginBottom: "32px" }}>
        Последна актуализация: октомври 2026 г.
      </p>

      <section style={{ marginBottom: "28px" }}>
        <h5>1. Кои сме ние</h5>
        <p>
          Stamsy Art е онлайн магазин за ръчно рисувани тениски, подаръци и сувенири,
          базиран в Пазарджик, България. Можете да се свържете с нас на{" "}
          <a href="mailto:stamsy.art@abv.bg">stamsy.art@abv.bg</a> или на телефон +359 893 231 708.
        </p>
      </section>

      <section style={{ marginBottom: "28px" }}>
        <h5>2. Какви данни събираме</h5>
        <p>При направена поръчка събираме:</p>
        <ul>
          <li>Три имена</li>
          <li>Имейл адрес</li>
          <li>Телефонен номер</li>
          <li>Адрес за доставка (при доставка до адрес)</li>
        </ul>
        <p>
          При регистрация с имейл събираме потребителско име, имейл адрес и парола
          (паролата се съхранява криптирана от Firebase Authentication).
        </p>
        <p>
          При вход с Google получаваме от Google вашето име, имейл адрес и снимка на
          профила. Използваме само името и имейла. Парола в този случай не пазим.
        </p>
        <p>
          Ако участвате в коледната игра, пазим и името и имейла от профила,
          дните, в които сте завъртели колелото, и спечелените кодове. Тези данни
          изтриваме до 31 януари 2027 г.
        </p>
      </section>

      <section style={{ marginBottom: "28px" }}>
        <h5>3. Защо събираме тези данни</h5>
        <p>Данните се използват единствено за:</p>
        <ul>
          <li>Обработка и изпълнение на поръчки</li>
          <li>Комуникация с клиента относно неговата поръчка</li>
          <li>Достъп до история на поръчките при влизане в профил</li>
          <li>Провеждане на коледната игра и връчване на наградите</li>
        </ul>
        <p>Не използваме вашите данни за маркетинг без изрично съгласие.</p>
      </section>

      <section style={{ marginBottom: "28px" }}>
        <h5>4. Бисквитки (Cookies)</h5>
        <p>
          Сайтът използва необходими бисквитки, за да запази вашия вход в профила
          и за чата на сайта (Tawk.to). Те не изискват съгласие.
        </p>
        <p>
          Само ако натиснете „Приемам“ в лентата за бисквитки, използваме и
          Google Analytics — за да знаем колко хора посещават сайта, от кои сайтове
          идват и кои страници разглеждат. Google Analytics поставя бисквитки
          (_ga, _ga_*), които се пазят до 2 години. Не използваме рекламни бисквитки.
        </p>
        <p>
          Можете да промените избора си по всяко време от връзката „Бисквитки“ най-долу
          на всяка страница.
        </p>
      </section>

      <section style={{ marginBottom: "28px" }}>
        <h5>5. Споделяне на данни</h5>
        <p>
          Вашите лични данни не се продават и не се споделят с трети страни с
          изключение на:
        </p>
        <ul>
          <li>
            <strong>Firebase (Google)</strong> — платформата, върху която работи сайтът.
            Данните се съхраняват на сървъри на Google съгласно техните условия.
          </li>
          <li>
            <strong>Google Analytics (Google)</strong> — само с ваше съгласие,
            за обобщена статистика за посещенията на сайта.
          </li>
          <li>
            <strong>EmailJS</strong> — услугата, чрез която изпращаме потвърдителни
            имейли за поръчки.
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: "28px" }}>
        <h5>6. Срок на съхранение</h5>
        <p>
          Данните от поръчки се съхраняват, докато не поискате тяхното изтриване.
          За да поискате изтриване на вашите данни, свържете се с нас на{" "}
          <a href="mailto:stamsy.art@abv.bg">stamsy.art@abv.bg</a>.
        </p>
      </section>

      <section style={{ marginBottom: "28px" }}>
        <h5>7. Вашите права</h5>
        <p>Съгласно GDPR имате право да:</p>
        <ul>
          <li>Получите копие на данните, които съхраняваме за вас</li>
          <li>Поискате корекция на неточни данни</li>
          <li>Поискате изтриване на вашите данни</li>
          <li>Подадете жалба до Комисията за защита на личните данни (КЗЛД)</li>
        </ul>
        <p>
          За всякакви въпроси относно личните ви данни пишете на{" "}
          <a href="mailto:stamsy.art@abv.bg">stamsy.art@abv.bg</a>.
        </p>
      </section>
    </div>
  );
};
